TS.ns('WL');

WL.requiredDocumentTypeModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var documentsList = me.getDomainProperty('grdReqDocTypeCollection_Property');

        if (documentsList !== null) {
            documentsList.on('cellValueChanged', me.onDocumentChanged);
            documentsList.on('afterAdd', me.onDocumentAdded);
        }

        var filterList = me.getDomainProperty('grdFilterCollection_Property');

        if (filterList !== null) {
            filterList.on('cellValueChanged', me.onFilterChanged);
            filterList.on('afterAdd', me.onFilterAdded);
            filterList.on('afterDelete', me.onFilterDeleted);
            filterList.on('cellBeginEdit', me.onFilterBeginEdit);
            filterList.on('propertyChanged', me.onFilterSelectionChanged);

            cat = filterList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'EditMultipleValuesFront';
            cmd['Text'] = me.EditMultipleValuesCommandText;
            cmd['handler'] = '_editMultipleValues';
            cmd['IconCode'] = 'ellipsis-v';
            cmd.Enabled(false);

            cat.push(cmd);
        }
    },

    onDocumentChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'ReqDocTypeId') {
            e.record.SharePointContentType(owner.findSharePointContentType(e.newValue));
        }
    },

    onDocumentAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    findSharePointContentType: function (ReqDocTypeId) {

        var ReqDocType = this.ReqDocTypeCollection().find(
            function (v) {
                return v.RequiredDocTypeId() === ReqDocTypeId;
            });

        if (ReqDocType === null) return null;

        return ReqDocType.SharePointContentType();
    },

    onFilterAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.OrderNo(this._ListSource().length);


        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    onFilterDeleted: function (e) {
        var me = this,
            owner = me._getOwner();
        var i;
        for (i = 0; i < me._ListSource().length; i++) {
            if (me._ListSource()[i].OrderNo() > e.item.OrderNo()) {
                me._ListSource()[i].OrderNo(me._ListSource()[i].OrderNo()-1);
            }
        }

        var filterList = owner.getDomainProperty('grdFilterCollection_Property');
        filterList.invalidate();
    },

    onFilterChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue === e.newValue)
            return;

        if (e.fieldName === 'ParamId' || e.fieldName === 'OperatorId') {
            owner.performServerCommand({ cmd: 'RefreshEditorType', submitModel: true, extraData: { Filter_UID: e.record.UID(), RequiredDoc_UID: owner.grdReqDocTypeCollection_Property.SelectedItem().UID()}, blockUI: true });
        }
    },

    onFilterBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;

        if (e.fieldName === 'FilterValueForDisplay' && e.record.MultipleSelection())
            e.preventDefault();
    },

    onFilterSelectionChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        owner._setEditValuesVisibility();
    },

    _editMultipleValues: function (e) {
        this.performServerCommand({
            cmd: 'EditMultipleValues',
            submitModel: true,
            extraData: {
                Filter_UID: this.grdFilterCollection_Property.SelectedItem().UID(),
                RequiredDoc_UID: this.grdReqDocTypeCollection_Property.SelectedItem().UID()
            },
            blockUI: true
        });
    },

    _setEditValuesVisibility: function () {
        var me = this;

        var filterList = me.getDomainProperty('grdFilterCollection_Property');
        if (filterList === null) return;

        var com = filterList.getCommand('EditMultipleValuesFront');

        if (com === null) return;

        var enableCommand = this._editMultipleValuesIsEnabled();

        com.Enabled(enableCommand);
    },

    _editMultipleValuesIsEnabled: function () {
        var docType = this.grdReqDocTypeCollection_Property.SelectedItem();

        if (docType === null) return false;

        var filter = this.grdFilterCollection_Property.SelectedItem();

        if (!filter) return false;

        if (filter.MultipleSelection == null) return false;

        if (filter.MultipleSelection() === null) return false;

        return filter.MultipleSelection();
    }

});